import { useEffect, useState } from 'react';
import Paragraph from '../../components/Typography/Paragraph';
import Heading from '../../components/Typography/Heading';
import Shape from '../../../../images/shape/shape-bookmark.svg';
import Button from '../../components/Button';
import { Search } from 'react-feather';
import { useNavigate } from 'react-router-dom';
import { useBookmark } from '../../hooks/useBookmark';
import CardBookmark from '../../components/Card/Bookmark';
import { Shape2 } from '../../components/CustomIcon';
import { RoutePaths } from '../../config/routes';
import Seo from '../../components/Seo';
var Bookmarks = function () {
    var navigate = useNavigate();
    var _a = useBookmark(), getBookmarks = _a.getBookmarks, bookmarks = _a.bookmarks, deleteBookmark = _a.deleteBookmark, getBookmarksExpires = _a.getBookmarksExpires;
    var _b = useState(false), ready = _b[0], setReady = _b[1];
    useEffect(function () {
        getBookmarks().then(function (data) { return setReady(true); });
    }, []);
    return (<>
      <Seo title="Vos recherches sauvegardées"/>
      <div className="p-default dark relative overflow-hidden bg-secondary-01">
        <div className="container">
          <div className="flex flex-col gap-6 md:w-2/3">
            <Heading level={1} type="h3">
              Mes recherches {(bookmarks === null || bookmarks === void 0 ? void 0 : bookmarks.length) > 0 ? "(".concat(bookmarks.length, ")") : null}
            </Heading>
            {getBookmarksExpires() ? (<div className="flex flex-col gap-4">
                <Paragraph size="lg">
                  Cette sauvegarde expirera{' '}
                  {getBookmarksExpires(true) === 1
                ? 'demain'
                : "dans ".concat(getBookmarksExpires(true), " jours")}
                </Paragraph>
                <Paragraph>
                  Vos recherches sauvegardées ont une durée de vie limitée. Pour y remédier, vous
                  pouvez{' '}
                  <a href={"/account/#".concat(RoutePaths.SIGN_IN_SITUATION)} className="underline">
                    créer un compte
                  </a>{' '}
                  ou{' '}
                  <a href={"/account/#".concat(RoutePaths.SIGN_IN)} className="underline">
                    vous connecter
                  </a>
                  .
                </Paragraph>
              </div>) : null}
          </div>
        </div>
        <div className="absolute top-0 right-0 z-90 hidden lg:block">
          <img className="relative left-0 right-0 block h-[400px] w-[400px]" src={Shape} alt="Forme"/>
        </div>
      </div>
      {ready ? (<div className="py-10">
          {!(bookmarks === null || bookmarks === void 0 ? void 0 : bookmarks.length) ? (<div className="flex flex-col items-center gap-6">
              <div className="flex flex-col gap-2 lg:w-5/12">
                <Heading level={2} type="h6" center>
                  Vous n’avez aucune recherche sauvegardée
                </Heading>
                <Paragraph center>
                  Effectuez une recherche sur Majeur·e·s pour découvrir les profils référencés et
                  sauvegarder ceux qui vous intéressent.
                </Paragraph>
              </div>
              <Button icon={Search} onClick={function () { return navigate('/'); }}>
                Trouver un·e professionnel·le
              </Button>
            </div>) : (<div className="container">
              <div className="flex flex-col gap-4">
                <Paragraph>
                  {bookmarks.length} recherche{bookmarks.length > 1 ? 's' : ''} sauvegardée
                  {bookmarks.length > 1 ? 's' : ''}
                </Paragraph>
                {bookmarks.map(function (bookmark) {
                    return (<CardBookmark bookmark={bookmark} onDelete={function () { return deleteBookmark(bookmark.id); }} key={bookmark.id}/>);
                })}
              </div>
            </div>)}
        </div>) : (<div className="flex items-center justify-center py-10">
          <Shape2 size={80} className="animate-spin"/>
        </div>)}
    </>);
};
export default Bookmarks;
